var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-photo-editor',{staticClass:"min-h-main",attrs:{"attachment":_vm.attachment,"read-only":!(_vm.isAdmin || (_vm.observation && _vm.me && _vm.attachment.createdBy === _vm.me.id && !_vm.observation.validatedAt))}})
}
var staticRenderFns = []

export { render, staticRenderFns }